// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6331":"dc0ef7bee9771633","9651":"539c7d5e89b2623e"}[chunkId] + ".js";
};